module.exports = __webpack_public_path__ + "img/eg.5a3e7a34.svg";